import { ReactComponent as LoveIt } from 'assets/images/videoReactions/loveIt.svg';
import styled from 'styled-components/macro';

const LoveItIcon = styled(LoveIt)`
  width: ${props => props.width || '24px'};
  height: ${props => props.height || '24px'};
`;

export default LoveItIcon;
